import type { ShipmentCheckCall } from "~/shared/schemas/shipment-management-schema";

import type { TrackingMessageAction } from "../../../utils/constants.ts";
import { getTrackingMessageActions } from "../../../utils/get-tracking-message-actions.ts";
import { GroupedFeedList } from "../../grouped-feed-list/grouped-feed-list.tsx";
import { TrackingHistoryItem } from "./tracking-history-item.tsx";

export const TrackingHistoryList = ({
	details,
	isSaving,
	canManageMessages,
	currentUserName,
	onSelect,
}: {
	details?: Record<string, ShipmentCheckCall[]>;
	isSaving: boolean;
	canManageMessages: boolean;
	currentUserName: string | null;
	onSelect: (
		checkCall: ShipmentCheckCall,
		action: TrackingMessageAction,
	) => void;
}) => (
	<GroupedFeedList
		getItemKey={(checkCall) => `${checkCall.timestamp}-${checkCall.enteredBy}`}
		groups={details}
		isLoading={isSaving}
		renderItem={(checkCall) => (
			<TrackingHistoryItem
				actions={
					canManageMessages
						? getTrackingMessageActions(checkCall.enteredBy, currentUserName)
						: []
				}
				checkCall={checkCall}
				isSaving={isSaving}
				onSelect={onSelect}
			/>
		)}
	/>
);
